(() => import(/* webpackMode: "lazy" */ "/ui/node_modules/swiper/swiper-bundle.min.css"));
(() => import(/* webpackMode: "lazy" */ "/ui/node_modules/swiper/swiper.min.css"));
import(/* webpackMode: "eager" */ "/ui/node_modules/next-runtime-env/build/env-provider.js");
import(/* webpackMode: "eager" */ "/ui/node_modules/next-runtime-env/build/use-env-context.js");
(() => import(/* webpackMode: "lazy" */ "/ui/src/assets/styles/global.css"));
import(/* webpackMode: "eager" */ "/ui/app/provider.jsx");
import(/* webpackMode: "eager" */ "/ui/src/components/listing-search/top-banner-ad/index.jsx");
import(/* webpackMode: "eager" */ "/ui/src/components/common/header/index.jsx");
import(/* webpackMode: "eager" */ "/ui/src/components/common/footer/index.jsx")